export default __webpack_public_path__ + "static/badge-blue-0057a2dafbd2ba3786dc37f3cc437b58.png";